import { LitElement, html } from 'lit-element';
import { HTMLChildrenMixin } from '../../kw-mixins/HTMLChildrenMixin';
import '../../kw-card-event/kw-card-event';
import '../../kw-carousel-interactive/kw-carousel-interactive';
import { kwWrapperEventsStyles } from './kw-wrapper-events-style';

const NUMBER_MONTH = {
  es: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
  en: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
};

function getRandomNumberImage(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function checkCapacity(event) {
  const defaultCapacity = 'kairos';
  const capacities = {
    dev: 'dev',
    agile: 'agile',
    devops: 'devops',
    data: 'data',
    corporate: 'corporate',
    design: 'design',
    innova: 'innova',

  };
  return capacities[event] ? capacities[event] : defaultCapacity;
}

function formatedEventDates(event, LANG) {
  const dateParts = new Date(event.startDate);
  const year = dateParts.getFullYear();
  const monthNumber = dateParts.getMonth();
  const month = NUMBER_MONTH[LANG][monthNumber];
  const day = dateParts.getDate();
  const hour = dateParts.getHours();
  const min = dateParts.getMinutes();
  const time = `${hour}:${min} GMT+1`;
  const eventDate = {
    year,
    month,
    day,
    time,
  };
  return eventDate;
}

function getSortedEvents(allValues, LANG) {
  const sortedEvents = allValues.map((event) => {
    const eventWithMonthLowerCase = event;
    eventWithMonthLowerCase.startDate.month = event.startDate.month.toLowerCase();
    return eventWithMonthLowerCase;
  });

  sortedEvents.sort((a, b) => {
    const year1 = a.startDate.year;
    const month1 = a.startDate.month;
    const day1 = a.startDate.day;
    const month2 = b.startDate.month;
    const day2 = b.startDate.day;
    const year2 = b.startDate.year;
    const indexMonth1 = NUMBER_MONTH[LANG].indexOf(month1);
    const indexMonth2 = NUMBER_MONTH[LANG].indexOf(month2);

    const date1 = new Date(
      year1,
      indexMonth1,
      day1,
    );
    const date2 = new Date(
      year2,
      indexMonth2,
      day2,
    );
    if (date2 < date1) return -1;
    if (date2 > date1) return 1;
    return 0;
  });
  return sortedEvents;
}

export const privateFns = {
  formatedEventDates,
  getRandomNumberImage,
  getSortedEvents,
};

export class KwWrapperEvents extends HTMLChildrenMixin(LitElement) {
  static get is() {
    return 'kw-wrapper-events';
  }

  static get styles() {
    return [kwWrapperEventsStyles];
  }

  static get properties() {
    return {
      /**
       * All data events
       * @property
       * @type {Array}
       */
      media: {
        type: Array,
      },
      /**
       * All past events
       * @property
       * @type {Array}
       */
      pastEvents: {
        type: Array,
      },
      /**
       * All now events
       * @property
       * @type {Array}
       */
      comingSoonEvents: {
        type: Array,
      },
      /**
       * All comming soon events
       * @property
       * @type {Array}
       */
      importantEvents: {
        type: Array,
      },
      /**
       * Date of event
       * @property
       * @type {String}
       */
      eventDate: {
        type: String,
      },
      /**
       * Past events months
       * @property
       * @type {Array}
       */
      pastEventsMonths: {
        type: Array,
        attribute: false,
      },
      /**
       *
       * @property
       * @type { String }
       */
      language: {
        type: String,
        attribute: 'language',
      },
    };
  }

  constructor() {
    super();
    this.pastEvents = [];
    this.language = '';
    this.comingSoonEvents = [];
    this.importantEvents = [];
    this.eventDate = '';
    this.pastEventsMonths = [];
    this.pageScroll = 0;
    this.hasImg = true;
    this.importantEventsTitle = '';
    this.comingEventsTitle = '';
    this._getPageScrol = this._getPageScrol.bind(this);
  }

  static _getArrayData(obj) {
    const objKeys = Object.keys(obj);
    const arrData = [];
    objKeys.forEach((objKey) => {
      arrData.push(obj[objKey]);
    });
    return arrData;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('item:open', this._handleOpenItemCard.bind(this));
    this.data = this._HTMLChildren();
    this.importantEventsTitle = this.data.titles['0'];
    this.comingEventsTitle = this.data.titles['1'];
    const eventsData = KwWrapperEvents._getArrayData(this.data.events);
    const formatedEvent = KwWrapperEvents._getDefaultImage(eventsData);
    const eventFormateddate = formatedEvent.map((event) => ({
      ...event,
      startDate: formatedEventDates(event, this.language),
      capacity: checkCapacity(event.capacity),
    }));
    this.media = eventFormateddate;
    this.pastEvents = getSortedEvents(this._filterDatePastEvents(), this.language);
    this.pastEventsMonths = this._getPastEventsUniqueMonths();
    this.comingSoonEvents = getSortedEvents(this._filterComingSoonEvents(), this.language);
    this.importantEvents = this._filterImportantEvents();
    this.importantEvents.sort((a, b) => ((a.position > b.position) ? 1 : -1));
    window.addEventListener('scroll', this._getPageScrol);
  }

  _filterComingSoonEvents() {
    const comingSoonEvents = this.media.filter((ev) => ev.comingEvent === 'true');
    return comingSoonEvents;
  }

  _filterImportantEvents() {
    const importantEvents = this.media.filter((ev) => ev.importantEvent === 'true');
    return importantEvents;
  }

  static _getDefaultImage(eventsArray) {
    const eventsWithImg = eventsArray.map((event) => {
      if (!event.imgMedium) {
        event.imgMedium = `/assets/images/events/random-headers/${event.capacity}/${event.capacity}${getRandomNumberImage(2, 4)}.svg`;
        event.defaultImg = true;
      }
      if (!event.imgLarge) {
        event.imgLarge = `/assets/images/events/random-headers/xl/${event.capacity}.svg`;
      }
      return event;
    });
    return eventsWithImg;
  }

  _filterDatePastEvents() {
    const formatedPastEvent = this.media.map((event) => {
      const formatedEvent = event;
      const today = new Date();
      const { year } = event.startDate;
      const { month } = event.startDate;
      const { day } = event.startDate;
      const indexMonth = NUMBER_MONTH[this.language].indexOf(month);
      const eventDate = new Date(
        year,
        indexMonth,
        day,
      );
      const result = today - eventDate;
      if (result > 0) {
        formatedEvent.eventPast = true;
      } else {
        formatedEvent.eventPast = false;
      }
      return formatedEvent;
    });
    const eventsPast = formatedPastEvent.filter((e) => e.eventPast === true);
    return eventsPast;
  }

  _getPastEventsUniqueMonths() {
    const allMonthsOFEvents = this.pastEvents.map((event) => `${event.startDate.month.toLowerCase()} ${event.startDate.year}`);
    return allMonthsOFEvents.filter((item, pos) => allMonthsOFEvents.indexOf(item) === pos);
  }

  _getPageScrol() {
    const elementeContainerPosition = [...this.shadowRoot.querySelectorAll('.kw-wrapper-events__list')];
    this.pageScroll = window.pageYOffset;
    elementeContainerPosition.forEach((itemAnimate) => {
      const cardsSmall = [...itemAnimate.querySelectorAll('.kw-cards__opacity')];
      if (this.pageScroll > itemAnimate.offsetTop - 600) {
        cardsSmall.forEach((item, i) => {
          this.addAnimationDelay(item, i);
        });
      }
    });
  }

  /* eslint-disable-next-line */
  addAnimationDelay(item, i) {
    setTimeout(() => {
      item.classList.add('kw-cards__animate');
    }, i * 300);
  }

  /* Handle toggle medium card in mobile version */

  changedAttributeCallback(name, oldval, newval) {
    super.changedAttributeCallback(name, oldval, newval);
    if (name === 'open') {
      this._handleOpenItem(
        { detail: { id: `item-${newval}`, open: true } },
        false,
      );
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('item:open', this._handleOpenItemCard);
  }

  _handleOpenItemCard(e, user = true) {
    const { id, open } = e.detail;
    const openItem = this.shadowRoot.getElementById(id);
    if (openItem && open) {
      const index = id.split('item-')[1];
      const othersOpen = Array.from(this.shadowRoot.querySelectorAll('[open]'))
        .filter((ev) => ev.id !== id);
      /* eslint no-param-reassign: ["error", { "props": false }] */
      othersOpen.forEach((item) => { item.open = false; });
      if (user) {
        this.open = index;
      }
    }
  }

  render() {
    return html`
      <div class="kw-wrapper-events__container">
        <div class="kw-wrapper-events__container--coming-soon-events">
          ${this.importantEvents.length > 0 ? html`
            <kw-title>
              <h3></h3>
              <h2>${this.importantEventsTitle}</h2>
            </kw-title>
            ${window.innerWidth < 768 ? html`
                ${this.importantEvents.map((event) => html`
                <kw-card-event
                  size-card="large"
                  .event="${event}"
                  imgGout="${`/assets/images/events/gouts/${event.capacity}-l.svg`}"
                ></kw-card-event>
                `)}
            ` : html`
              <kw-carousel-interactive>
              ${this.importantEvents.map((event) => html`
                <kw-card-event
                  size-card="large"
                  .event="${event}"
                  imgGout="${`/assets/images/events/gouts/${event.capacity}-l.svg`}"
                ></kw-card-event>`)},
            </kw-carousel-interactive>
            `}` : ''}
        </div>

        <div class="kw-wrapper-events__container--now-events">
          <kw-title>
            <h3></h3>
            <h2>${this.comingEventsTitle}</h2>
          </kw-title>
          <div class="kw-wrapper-events__list kw-wrapper-events__list--now-events">
            ${this.comingSoonEvents.map((event, index) => html`
            <div class="kw-cards__opacity">
            <kw-card-event
              id="item-${index}"
              ?open=${this.open === index}
              size-card="medium"
              .event="${event}"
              imgGout="${`/assets/images/events/gouts/${event.capacity}-l.svg`}"
            ></kw-card-event><div>`)}
          </div>
        </div>

        <div id="pastEvents">
          ${this.pastEventsMonths.map((event) => html`
            <kw-title>
              <h3></h3>
              <h2>${event}</h2>
            </kw-title>
            <div class="kw-wrapper-events__list kw-wrapper-events__list--past-events">
              ${this.pastEvents.map((pastEvent) => html`
                ${`${pastEvent.startDate.month.toLowerCase()} ${pastEvent.startDate.year}` === event.toLowerCase() ? html`
                <div class="kw-cards__opacity">
                  <kw-card-event
                    size-card="small"
                    .event="${pastEvent}"
                    imgGout="${`/assets/images/events/gouts/${pastEvent.capacity}-s.svg`}"
                  ></kw-card-event> <div>` : ''}
              `)}
            </div>
          `)}
        </div>
      </div>
    `;
  }
}
